<template>
  <v-container>
    <OverlayLoader :overlay="overlay" :text="'카카오톡 로그인'" />
  </v-container>
</template>

<script>
import OverlayLoader from "@/components/OverlayLoader.vue";
export default {
  name: "KakaoLogin",
  components: {
    OverlayLoader,
  },
  data() {
    return {
      overlay: true,
      tokenResult: undefined,
      code: undefined,
      userProfile: undefined,
      result: undefined,
    };
  },
  methods: {
    loginWithKakao() {
      window.Kakao.Auth.authorize({
        redirectUri: process.env.VUE_APP_SERVICE_URL + "/social/kakao/",
      });
    },
    getInfo() {
      var vm = this;
      window.Kakao.API.request({
        url: "/v2/user/me",
        success: function (res) {
          vm.userProfile = res;
        },
        fail: function (error) {
          console.log(
            "login success, but failed to request user information: " +
              JSON.stringify(error)
          );
        },
      });
    },
    getToken() {
      this.$axios
        .post("/users/social/kakao", {
          code: this.code,
        })
        .then(async (response) => {
          if (response.data.success) {
            this.tokenResult = response.data.result;
            const token = this.tokenResult.access_token;
            if (token) {
              await window.Kakao.Auth.setAccessToken(token);
              await this.getInfo();
            }
          } else {
            this.overlay = false;
            this.$router.push("/");
          }
        });
    },
    kakaoHandle() {
      this.$axios
        .post("/users/social/handle", {
          type: "kakao",
          data: this.userProfile,
          auth: this.tokenResult,
        })
        .then(async (response) => {
          if (response.data.success) {
            await this.$store.dispatch("login", {
              body: response.data.result.auth_info,
            });

            this.overlay = false;
            if (response.data.first === true) {
              this.$router.push("/tutorial");
            } else {
              this.$router.push("/division");
            }
          }
        });
    },
  },
  mounted() {
    this.code = this.$route.query.code;
    if (this.code) {
      this.getToken();
    } else {
      this.loginWithKakao();
    }
  },
  watch: {
    userProfile() {
      this.kakaoHandle();
    },
  },
};
</script>